import React from "react";
import Image from "next/image";
import {AccreditationSmallSection} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
// import { logger } from '@/lib/logger';

interface TrustSmallProps {
  blok?: AccreditationSmallSection & SbBlokData;
  title?: string;
}

const TrustSmall: React.FC<TrustSmallProps> = ({
  blok,
  title,
}) => {
  const accreditations = blok?.accreditations || [];

  // logger.log(`blok: ` + JSON.stringify(blok?.data?.story?.content, null, 2));

  return (
    <div {...(blok && storyblokEditable(blok))} className="card card-lighter p-3">
      <h2 className="small text-center text-uppercase h-ruled mb-3">
        {title || "A trusted USA cybersecurity service provider"}
      </h2>

      <div className="row align-items-center justify-content-center g-2 g-sm-3">
        {accreditations.map((item) => (
          <div className="col-auto" key={item._uid}>
            <Image
              src={item.image?.filename || ""}
              width={Number(item.width) || 46}
              height={Number(item.height) || 46}
              alt={item.alt_image || "Accreditation logo"}
              title={item.alt_image || "Accreditation logo"}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="eager"
              quality={75}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSmall;
